import getData from './get-data';
import toFixed from '/src/scripts/rebuild/toFixed.js';
import pageList from '/src/__data-store/page-list.json';

export default async (allAssets, reqArr) => {
    await getData(allAssets, reqArr)

    const langPrefix = document.querySelector('#all-assets').getAttribute('data-lang')
    const box = document.querySelector('.assets__body')
    let result = ''

    for (let key of reqArr) {
        const data = allAssets[key]
        const {
            short,
            fullName,
            price,
            change24,
            rewards,
            isInWallet,
            isInCalc,
            status,
        } = data
        const {
            buy,
            sell
        } = status

        if (!data 
            || price === 'undefined' 
            || !change24 
            || !fullName
            || !isInWallet
            ) continue
        
        const fixedFull = fullName === 'HarryPotterObamaPacMan8Inu' ? 'Xrp' : fullName;
        const walletLinkDefault = `/${fixedFull.toLowerCase().replace(/ /g, '-')}-wallet`
        const walletLinkLang = langPrefix + walletLinkDefault
        let curWalletLink = walletLinkDefault
        if (pageList.includes(walletLinkLang)) curWalletLink = walletLinkLang

        //template parts
        const rewardsTmpt = rewards ? `<span class="assets__rewards">+${rewards}%</span>` : ''
        const sendOrRecieveTmpt = short === 'XMR' ?  '' : `<img class="assets__check" src="/images/all-assets/check.svg" alt=""></img>`
        const swapTmpt = buy && sell ? `<img class="assets__check" src="/images/all-assets/check.svg" alt=""></img>` : ''
        const buyLinkTmpt = isInCalc ? `<a href="buy-${fixedFull.replace(/ /g, "-").toLowerCase()}" class="assets__buy">Buy</a>` : ''
        const dif = change24.toString()[0] === '-' ? 'assets__dif--red' : 'assets__dif--green'
        const downloadTmpt = isInWallet ? `<a class="assets__button assets__button--download" href="${ curWalletLink }">Download</a>` : ''

        //final template
        const tmpt = `<li class="assets__item">
                        <div class="assets__sort-left">
                            <div class="assets__asset">
                                <img class="assets__icon" src="/images/coins-auto-updating/${short}.png" alt="">
                                <p class="assets__coin">${fixedFull} <span class="assets__short">${short}</span></p>
                            </div>
                            ${buyLinkTmpt}
                        </div>
                        <div class="assets__sort-right">
                            <div class="assets__price assets__grid-price assets__body-item">
                                <span class="assets__sum">$${toFixed(price)}</span>
                                <span class="assets__dif ${dif}">${toFixed(change24)}%</span>
                            </div>
                            <div class="assets__send assets__grid-send assets__body-item">
                                ${sendOrRecieveTmpt}
                            </div>
                            <div class="assets__swap assets__grid-swap assets__body-item">
                                ${swapTmpt}
                            </div>
                            <div class="assets__grid-rewards assets__body-item">${rewardsTmpt}</div>
                            <div class="assets__grid-download assets__body-item">
                                ${downloadTmpt}
                            </div>
                        </div>
                    </li>`

        result += tmpt
    }

    const emptyTmpt = `<div class="assets__empty">
                            <p class="assets__empty-title">Oops, not found!</p>
                            <p class="assets__empty-text">Atomic supports any Ethereum (ERC20) and Binance Smart Chain (BEP20) tokens by default <a class="assets__empty-link" href="https://support.atomicwallet.io/article/42-how-to-add-a-custom-erc20-eth-token">Learn more</a></p>
                            <div class="assets__empty-buttons">
                                <button data-popup="popup-form" class="assets__empty-button assets__empty-button--white">Be the first to get our latest news and updates <img class="assets__empty-icon" src="/images/all-assets/mail-icon.png" alt=""></button>
                                <a href="https://atomicwallet.io/support" class="assets__empty-button assets__empty-button--blue" target="_blank">Let us know what coin you'd like to see in our wallet <img class="assets__empty-icon" src="/images/all-assets/bulb-icon.png" alt=""></a>
                            </div>
                        </div>`
    //check if no result and add empty screen
    let isEmpty = false;
    if (!result.length) {
        isEmpty = true;
        result = emptyTmpt
    }

    box.innerHTML = result

    //add btn click event to show popup if empty table
    if (isEmpty)  { 
        box.querySelector('[data-popup="popup-form"]').addEventListener('click', function(){
            let popup = document.querySelector('.modal-overlay#popup-form')
            popup.classList.add('open')
        })
    }
}